import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    number: '1',
    title: 'Información general',
    content: (
      <p>
        Laura Soto Shop es una tienda online ubicada en Villavicencio, Colombia, dedicada a la
        venta de ropa y perfumes originales. Para contacto:{' '}
        <a
          href="mailto:sotovalderramalaurayisel@gmail.com"
          className="text-amber-600 hover:underline"
        >
          sotovalderramalaurayisel@gmail.com
        </a>
      </p>
    ),
  },
  {
    number: '2',
    title: 'Productos',
    content: (
      <ul className="list-disc list-inside space-y-2">
        <li>Todos nuestros productos son originales.</li>
        <li>Las imágenes son de referencia y pueden presentar ligeras variaciones.</li>
        <li>La disponibilidad está sujeta a inventario.</li>
      </ul>
    ),
  },
  {
    number: '3',
    title: 'Precios',
    content: (
      <ul className="list-disc list-inside space-y-2">
        <li>Todos los precios están en pesos colombianos (COP).</li>
        <li>Pueden cambiar sin previo aviso.</li>
        <li>Las promociones tienen tiempo limitado.</li>
      </ul>
    ),
  },
  {
    number: '4',
    title: 'Pedidos',
    content: (
      <ul className="list-disc list-inside space-y-2">
        <li>Los pedidos se confirman una vez se verifique el pago.</li>
        <li>
          Nos reservamos el derecho de cancelar pedidos por errores en precios o disponibilidad.
        </li>
      </ul>
    ),
  },
  {
    number: '5',
    title: 'Pagos',
    content: (
      <p>
        Los pagos se realizan a través de los medios acordados con el cliente, incluyendo canales
        digitales como transferencias o WhatsApp.
      </p>
    ),
  },
  {
    number: '6',
    title: 'Envíos',
    content: (
      <ul className="list-disc list-inside space-y-2">
        <li>Realizamos envíos a nivel nacional desde Villavicencio.</li>
        <li>Los tiempos de entrega pueden variar según la ubicación.</li>
        <li>No nos hacemos responsables por retrasos atribuibles a la transportadora.</li>
      </ul>
    ),
  },
  {
    number: '7',
    title: 'Cambios y devoluciones',
    content: (
      <ul className="list-disc list-inside space-y-2">
        <li>Solo aplican por defectos de fábrica o errores en el pedido.</li>
        <li>Deben reportarse dentro de las primeras 24 a 48 horas tras la entrega.</li>
        <li>El producto debe estar sin uso y en su empaque original.</li>
      </ul>
    ),
  },
  {
    number: '8',
    title: 'Uso del sitio',
    content: (
      <p>
        El usuario se compromete a utilizar este sitio de forma adecuada y sin fines fraudulentos.
      </p>
    ),
  },
  {
    number: '9',
    title: 'Propiedad intelectual',
    content: (
      <p>
        Todo el contenido del sitio (textos, imágenes, diseño) es propiedad de Laura Soto Shop y
        no puede ser utilizado sin autorización.
      </p>
    ),
  },
  {
    number: '10',
    title: 'Contacto',
    content: (
      <div className="space-y-2">
        <p>Puedes comunicarte con nosotros a través de:</p>
        <p>
          📧{' '}
          <a
            href="mailto:sotovalderramalaurayisel@gmail.com"
            className="text-amber-600 hover:underline"
          >
            sotovalderramalaurayisel@gmail.com
          </a>
        </p>
        <p>📱 WhatsApp (canal principal de atención)</p>
      </div>
    ),
  },
];

export default function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Términos de Servicio | Laura Soto Shop';

    const existing = document.getElementById('ld-terms');
    if (existing) existing.remove();

    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Términos de Servicio — Laura Soto Shop",
      "description": "Términos y condiciones de uso de Laura Soto Shop, tienda de ropa y perfumes originales en Villavicencio, Colombia.",
      "url": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/terminos`,
      "inLanguage": "es",
      "isPartOf": {
        "@type": "WebSite",
        "name": "Laura Soto Shop",
        "url": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/`
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'ld-terms';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('ld-terms');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-stone-900 text-white py-16 px-6">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 text-sm mb-8 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Volver al inicio
          </Link>
          <p className="text-xs tracking-[0.2em] text-amber-400 uppercase mb-3 font-sans">
            Laura Soto Shop
          </p>
          <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4">Términos de Servicio</h1>
          <p className="text-stone-400 text-sm font-sans">
            Al acceder y utilizar este sitio web, aceptas los siguientes términos y condiciones.
            Si no estás de acuerdo, te recomendamos no utilizar nuestros servicios.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="space-y-10">
          {sections.map((sec) => (
            <div key={sec.number} className="border-b border-stone-100 pb-10 last:border-0">
              <div className="flex items-start gap-5">
                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center font-sans font-bold text-amber-600 text-sm">
                  {sec.number}
                </span>
                <div className="flex-1 pt-1">
                  <h2 className="font-serif text-xl font-bold text-stone-900 mb-3">{sec.title}</h2>
                  <div className="font-sans text-sm text-stone-600 leading-relaxed">
                    {sec.content}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer CTA */}
        <div className="mt-16 bg-amber-50 border border-amber-200 rounded-2xl p-8 text-center">
          <p className="font-serif text-xl font-bold text-stone-900 mb-2">¿Tienes alguna duda?</p>
          <p className="font-sans text-sm text-stone-600 mb-6">
            Contáctanos y te respondemos con gusto.
          </p>
          <a
            href="https://wa.me/573228000501"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5A] text-white font-sans text-sm font-semibold px-8 py-3 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-fill text-lg" />
            Escríbenos por WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
